import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { schemaTemplatesSystemMail } from '../tables';

type Arguments = {
    position?: number;
};

export const schemaTemplateResolver_GetSystemMailTemplates = z.array(schemaTemplatesSystemMail);

export type SchemaTemplateResolver_GetSystemMailTemplates = z.infer<
    typeof schemaTemplateResolver_GetSystemMailTemplates
>;

export type TemplateResolver_GetSystemMailTemplates = Resolver<
    Arguments,
    SchemaTemplateResolver_GetSystemMailTemplates
>;
